module.exports = __webpack_public_path__ + "img/bf-logo-smile-dark.d6f87808.svg";